// import GreetingSection from 'components/navbar/GreetingSection';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
  Input,
  Row,
  Col,
  Divider,
  Button,
  // Grid,
  Switch,
  Radio,
  Checkbox,
  // Typography,
  Form,
  Alert,
} from 'antd';
import {
  // usePolicyDropDown,
  useLifeBeneficiariesInfoNew,
  useGetCountriesNew,
  useIdType,
} from 'all-in-one-shared-api';
import { useEffect, useState, Fragment } from 'react';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { PolicyDropDown } from 'all-in-one-shared-api/dist/apis/policy/usePolicyDropDown';
import { isLocaleEnglish } from 'utils/languageUtils';
import KnowMoreArrowIcon from 'assets/images/home/chevron-right-red.svg';
import { Spinner } from 'components';
import IrrevocableIcon from 'assets/images/policy/Irrevocable.svg';
import edit from 'assets/images/MakeRequest/edit.svg';
import editdisabled from 'assets/images/MakeRequest/editdisabled.svg';
import Added from 'assets/images/MakeRequest/Added.svg';
// import { sessionStorageService } from 'utils/SessionStorageService';
import { ChangeBeneficiariesCard } from 'pages/lifeBeneficiaries/components/ChangeBeneficiariesCard';
import moment from 'moment';

import removeIcon from 'assets/images/MakeRequest/remove.svg';
import './ChangeBeneficiaries.less';
import {
  CommonTnc,
  //  AgreementCheckbox
} from 'components/CommonTncBn';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { useBeneficiaries } from 'contexts/beneficiaries/context';
import { PEPForm, beneficiaryInfo, beneficiariesForm } from 'contexts/beneficiaries/beneficiariesForm';
import { BeneficiariesActionTypes } from 'contexts/beneficiaries/action';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
// import Close from 'assets/images/liHome/close.svg';
// const { Title } = Typography;
import Modal from './components/modal';
// const { Option } = Select;
const ViewBeneficiariesContainer = styled.div`
  margin: 0;
`;
// const { useBreakpoint } = Grid;
interface PdRowProps {
  paddingFlag?: string;
  padB?: string;
}
interface DividerLineProps {
  padB?: string;
}
interface OutletContextType {
  selectItem: PolicyDropDown;
  dropData: PolicyDropDown[];
}
interface LocationState {
  // policyNo?: string;
  // companyNo?: string;
  editflag: boolean;
  selectItem: PolicyDropDown;
}
interface countrylist {
  label: string;
  value: string;
  descEn: string;
  descTc: string;
  riskLevel: string;
  code: string;
  isSanction: boolean;
}
const StyledBlock = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`;
const Androw = styled(Row)<PdRowProps>`
  max-width: 640px;
  margin: 0 auto;
  // background: #fff;
  padding-top: ${(props) => (props.paddingFlag ? props.paddingFlag : `0`)};
  padding-bottom: ${(props) => (props.padB ? props.padB : `0`)};
`;
const AndCol = styled(Col)`
  margin: 0 20px;
`;
const AntDivider = styled(Divider)`
  border-color: #cccccc;
`;
const FlexCol = styled(Col)<{ flag?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: ${(props) => (props.flag ? '0 16px' : '0')};
`;
const KnowMoreLinkImage = styled.img`
  margin-left: 12px;
  width: 14px;
  height: 8px;
`;
export default function ViewBeneficiaries() {
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  const location = useLocation();
  const { token } = useKeycloakReady();
  const [Errmessage, setErrmessage] = useState<string>('Errmessage');
  const [EditDisable, setEditDisable] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(false);
  const {
    // policyNo,
    // companyNo,
    editflag,
    // selectItem,
  } = (location.state as LocationState) ?? {};
  const [policyNumber, setPolicyNumber] = useState('');
  const [companyCode, setCompanyCode] = useState('');
  const { selectItem, dropData } = useOutletContext<OutletContextType>();
  // const [selectItem, setSelectItem] = useState<PolicyDropDown>();
  const [randoms, setRandoms] = useState(Math.random());
  const [primaryData, setPrimaryData] = useState<beneficiariesForm[]>([]);
  const [secondary, setSecondary] = useState<beneficiariesForm[]>([]);
  const [totalShares, setTotalShares] = useState('0%');
  const [totalSharesSec, setTotalSharesSec] = useState('0%');
  const [primaryRemove, setPrimaryRemove] = useState(false);
  const [secondaryRemove, setSecondaryRemove] = useState(false);
  const [firstFlag, setFirstFlag] = useState(true);
  const [EditCode, setEditCode] = useState<boolean>(editflag ? editflag : false);
  const [listdata, setListdata] = useState<beneficiariesForm[]>([]);
  const {
    policyNC,
    state,
    dispatch,
    setOldBeneficiariesList,
    oldBeneficiariesList,
    setPep,
    pep,
    setCompanyCodeNc,
    companyCodeNc,
    setHighRiskP,
  } = useBeneficiaries();
  const [removeConfrimModal, setRemoveConfrimModal] = useState(false);
  const [removeSingleData, setRemoveSingleData] = useState<beneficiariesForm>();
  const [pepEdit, setPepEdit] = useState(false);
  const [checkValue, setCheckValue] = useState(false);
  const [oldCheckValue, setOldCheckValue] = useState(false);
  const [changeEsConfrimModal, setChangeEsConfrimModal] = useState(false);
  const [pTotalS, setPTotalS] = useState(false);
  const [sTotalS, setSTotalS] = useState(false);
  const [mes, setMes] = useState<string>('');
  const navigate = useNavigate();
  // const { xs, lg } = useBreakpoint();
  const [startLoading, setStartLoading] = useState<boolean>(false);
  const [editOrAddShow, setEditOrAddShow] = useState<boolean>(false);
  const [type, setType] = useState<string>('');
  const [editCodeFlag, setEditCodeFlag] = useState<string>('');
  const { shouldFetch, data } = useLifeBeneficiariesInfoNew(
    'useLifeBeneficiariesInfoNew' + randoms,
    token ?? '',
    policyNumber,
    companyCode,
    {
      onSuccess: () => {
        setStartLoading(false);
      },
      onError: () => {
        setStartLoading(false);
      },
    },
  );
  const [form] = Form.useForm();
  const [myCountryList, setMyCountryList] = useState<countrylist[]>([]);
  const [idTypeList, setIdTypeList] = useState<
    {
      label: string;
      value: string;
      descEn: string;
      descTc: string;
    }[]
  >([]);
  const { shouldFetch: shouldFecthGetCountry, data: countriesDataList } = useGetCountriesNew(
    'useGetCountriesNew',
    token ?? '',
    policyNC ?? '',
    companyCodeNc ?? '',
  );
  const { data: idType, shouldFetch: shouldFetchIdType } = useIdType(token ?? '');

  // const { shouldFetch: shouldFecthDrop, data: dropData } = usePolicyDropDown('usePolicyDropDown', token ?? '');
  // const changeOptions = (value: string) => {
  //   setEditCode(false);
  //   setPolicyNumber(value);
  //   setSelectItem(dropData?.filter((item) => item.policyNumber === value)[0]);
  // };
  const Edit = () => {
    setEditCode(true);
  };
  // useEffect(() => {
  //   if (policyNo && companyNo) {
  //     console.log('监听policyNo');
  //     setPolicyNumber(policyNo);
  //     setCompanyCode(companyNo);
  //   }
  // }, [policyNo, companyNo]);
  useEffect(() => {
    if (countriesDataList && countriesDataList?.residentialCountries) {
      shouldFecthGetCountry(false);
      setMyCountryList(
        countriesDataList?.residentialCountries.map((item) => {
          return {
            label: isEnglish ? item.countryName : item.countryNameTc,
            value: item.t3645Alpha3Country,
            riskLevel: item.riskLevel,
            code: item.t3645Alpha3Country,
            descEn: item.countryName,
            descTc: item.countryNameTc,
            isSanction: item.isSanction,
          };
        }),
      );
    }
    if (idType) {
      shouldFetchIdType(false);
      setIdTypeList(
        idType.map((item) => {
          return {
            label: isEnglish ? item.idTypeDesc : item.idTypeDescTc,
            value: item.idType,
            descEn: item.idTypeDesc,
            descTc: item.idTypeDescTc,
          };
        }),
      );
    }
  }, [countriesDataList, isEnglish, shouldFecthGetCountry, shouldFetchIdType, idType]);
  useEffect(() => {
    if (editflag) {
      setFirstFlag(false);
    } else {
      setFirstFlag(true);
    }
    setEditCode(editflag);
  }, [editflag]);
  useEffect(() => {
    if (policyNC) {
      setPolicyNumber(policyNC);
      setPrimaryRemove(false);
      setSecondaryRemove(false);
      setCompanyCode(companyCodeNc);
      setPep({
        type: 'RESET_PEP',
      });
      if (selectItem) {
        setCompanyCode(selectItem.companyCode);
        setCompanyCodeNc(selectItem.companyCode);
      }
    }
  }, [policyNC, selectItem, setCompanyCodeNc, companyCodeNc, setPep]);
  useEffect(() => {
    if (pep.isDeclaration == 'Yes') {
      form.setFieldsValue(pep);
    }
    if (!firstFlag) {
      // setPrimaryRemove(false);
      // setSecondaryRemove(false);
      setListdata([...state]);
      if (state?.length > 0) setRemoveConfrimModal(false);
      // setStartLoading(false);
    }
    // eslint-disable-next-line
  }, [firstFlag, state]);
  useEffect(() => {
    if (!data) return;
    if (myCountryList.length == 0) return;
    if (idTypeList.length == 0) return;
    // shouldFetch(false);
    // setLoading(false);
    if (data.policyHighRisk == 'Y') {
      setHighRiskP(true);
    } else {
      setHighRiskP(false);
    }

    if (data.beneficiariesDataList && data.beneficiariesDataList.length > 0) {
      const arr: beneficiaryInfo[] = data?.beneficiariesDataList?.map((item) => ({
        ...item,
        id: Math.random()
          .toString(36)
          .substring(2, 2 + 8),
        beneficiaryAction: 'no change',
        birthCountryDesc: item.birthCountry
          ? myCountryList.find((country) => country.code == item.birthCountry)?.descEn
          : '',
        birthCountryDescTc: item.birthCountry
          ? myCountryList.find((country) => country.code == item.birthCountry)?.descTc
          : '',
        residenceCountryDesc: item.residenceCountry
          ? myCountryList.find((country) => country.code == item.residenceCountry)?.descEn
          : '',
        residenceCountryDescTc: item.residenceCountry
          ? myCountryList.find((country) => country.code == item.residenceCountry)?.descTc
          : '',
        taxResidenceDesc: item.taxResidence
          ? myCountryList
              .filter((country) => item.taxResidence?.includes(country.code))
              .map((item) => item.descEn)
              .join(';')
          : '',
        taxResidenceDescTc: item.taxResidence
          ? myCountryList
              .filter((country) => item.taxResidence?.includes(country.code))
              .map((item) => item.descTc)
              .join(';')
          : '',
        genderDesc: item.gender ? (item.gender == 'M' ? 'Male' : 'Female') : '',
        genderDescTc: item.gender ? (item.gender == 'M' ? '男' : '女') : '',
        idTypeDesc: item.idType ? idTypeList.find((idt) => idt.value == item.idType)?.descEn : '',
        idTypeDescTc: item.idType ? idTypeList.find((idt) => idt.value == item.idType)?.descTc : '',
        birthDate:
          item.birthDate && item.birthDate != 'null' ? moment(item.birthDate, 'YYYYMMDD').format('DD/MM/YYYY') : '',
      }));
      if (firstFlag) {
        form.setFieldValue('isDeclaration', 'No');
        const primary = arr.filter((item) => item.role !== 'G');
        const secondary = arr.filter((item) => item.role === 'G');
        if (primary.length == 1 && primary[0].relationship == 'ES') {
          dispatch({
            type: BeneficiariesActionTypes.SET,
            payload: [...arr.filter((item) => item.role === 'G')],
          });
        } else if (secondary.length == 1 && secondary[0].relationship == 'ES') {
          dispatch({
            type: BeneficiariesActionTypes.SET,
            payload: [...arr.filter((item) => item.role !== 'G')],
          });
        } else {
          dispatch({
            type: BeneficiariesActionTypes.SET,
            payload: [...arr],
          });
        }
        setListdata(arr);
        setOldBeneficiariesList(arr);
      }
    } else {
      if (firstFlag) {
        setListdata([]);
        setOldBeneficiariesList([]);
        dispatch({
          type: BeneficiariesActionTypes.SET,
          payload: [],
        });
      }
    }
    // eslint-disable-next-line
  }, [data, myCountryList, idTypeList]);
  useEffect(() => {
    if (data)
      if (data.changeStatusCode && data.changeStatusCode !== 'None' && data.changeStatusCode !== '') {
        setEditDisable(true);
        if (isEnglish) {
          setErrmessage(data?.changeStatusDesc ?? '');
        } else {
          setErrmessage(data?.changeStatusDescTc ?? '');
        }
      } else if (data.beneficiariesDataList && data.beneficiariesDataList.some((item) => item.irrevocableFlag)) {
        setEditDisable(true);
        setErrmessage(t('life.beneficiaries.irrevocable'));
        // if (i18n.language == 'en') {
        //   setErrmessage(
        //     'As the signature of irrevocable beneficiary is required, please download the form below to make a change request.',
        //   );
        // } else {
        //   setErrmessage('由於此更改需不可撤换受益人簽署，請下载下面的表格以提出更改申請。');
        // }
      } else {
        setEditDisable(false);
        setErrmessage('');
      }
  }, [data, isEnglish, t]);

  useEffect(() => {
    setPepEdit(listdata.some((item) => item.beneficiaryAction == 'add' || item.beneficiaryAction == 'updated'));
    const primaryData = listdata.filter((item) => item.role !== 'G');
    const secondary = listdata.filter((item) => item.role === 'G');
    setPrimaryData(primaryData.length == 1 && primaryData[0].relationship == 'ES' ? [] : primaryData);
    setSecondary(secondary.length == 1 && secondary[0].relationship == 'ES' ? [] : secondary);
    const totalShares = primaryData.reduce((sum, item) => {
      if (primaryData.length == 1 && item.relationship == 'ES') return 0;
      let share = 0;
      if (item.beneficiaryAction == 'removed') share = 0;
      else {
        if (item.share && item.share?.indexOf('%') != -1) share = parseFloat(item.share.replace('%', '')) || 0;
        else share = parseFloat(item?.share ?? '0') || 0;
      }
      return sum + share;
    }, 0);
    const totalSharesSec = secondary.reduce((sum, item) => {
      let share = 0;
      if (item.beneficiaryAction == 'removed') share = 0;
      else {
        if (item.share && item.share?.indexOf('%') != -1) share = parseFloat(item.share.replace('%', '')) || 0;
        else share = parseFloat(item.share ?? '0') || 0;
      }
      return sum + share;
    }, 0);
    setTotalShares(`${totalShares}%`);
    setTotalSharesSec(`${totalSharesSec}%`);
    if (firstFlag) {
      setCheckValue(
        (primaryData?.length == 0 && secondary?.length == 0) ||
          (primaryData.length == 1 && primaryData[0].relationship == 'ES') ||
          (primaryData.length == 1 && primaryData[0].relationship == 'ES'),
      );
      setOldCheckValue(
        (primaryData?.length == 0 && secondary?.length == 0) ||
          (primaryData.length == 1 && primaryData[0].relationship == 'ES') ||
          (primaryData.length == 1 && primaryData[0].relationship == 'ES'),
      );
    } else setCheckValue(checkValue);
    // eslint-disable-next-line
  }, [listdata]);
  useEffect(() => {
    if (policyNumber && companyCode) {
      setEditOrAddShow(false);
      setFirstFlag(true);
      setMes('');
      setSTotalS(false);
      setPTotalS(false);
      // if (firstFlag) {
      setStartLoading(true);
      setRandoms(Math.random());
      shouldFetch(true);
      shouldFecthGetCountry(true);
      shouldFetchIdType(true);
      // }
    }
    // shouldFecthDrop(true);
    // eslint-disable-next-line
  }, [policyNumber, companyCode]);
  const DividerLine = ({ padB }: DividerLineProps) => {
    return (
      <Androw justify="start" padB={padB}>
        <AndCol style={{ width: '100%' }}>
          <AntDivider style={{ margin: '12px 0' }}></AntDivider>
        </AndCol>
      </Androw>
    );
  };
  const toDownload = () => {
    if (policyNumber == '') {
      navigate('/MakeRequestPage', {
        state: {
          tabs: 0,
        },
      });
      return;
    }
    if (isEnglish) {
      if (data?.downloadServiceFormEn) {
        const link = document.createElement('a');
        const url = data.downloadServiceFormEn;
        link.href = url;
        link.target = '_blank';
        link.rel = 'noreferrer';
        link.download = 'filename.pdf';
        document.body.appendChild(link);
        // link.click();
        const e = document.createEvent('MouseEvent');
        e.initEvent('click', false, false);
        link.dispatchEvent(e);
      }
    } else {
      if (data?.downloadServiceFormTc) {
        const link = document.createElement('a');
        const url = data.downloadServiceFormTc;
        link.href = url;
        link.target = '_blank';
        link.rel = 'noreferrer';
        link.download = 'filename.pdf';
        document.body.appendChild(link);
        // link.click();
        const e = document.createEvent('MouseEvent');
        e.initEvent('click', false, false);
        link.dispatchEvent(e);
      }
    }
  };
  const SwitchonChange = (checked: boolean) => {
    setMes('');
    setPTotalS(false);
    setSTotalS(false);
    form.setFieldsValue({
      isDeclaration: 'No',
      pepName: '',
      pepPosition: '',
      relevantPartyName: '',
      pepRelationship: '',
    });
    setPep({ type: 'RESET_PEP' });
    if (checked) setChangeEsConfrimModal(true);
    else {
      const primary = oldBeneficiariesList.filter((item) => item.role !== 'G');
      const secondary = oldBeneficiariesList.filter((item) => item.role === 'G');
      if (primary.length == 1 && primary[0].relationship == 'ES') {
        dispatch({
          type: BeneficiariesActionTypes.SET,
          payload: [...secondary],
        });
      } else if (secondary.length == 1 && secondary[0].relationship == 'ES') {
        dispatch({
          type: BeneficiariesActionTypes.SET,
          payload: [...primary],
        });
      } else {
        dispatch({
          type: BeneficiariesActionTypes.SET,
          payload: [...oldBeneficiariesList],
        });
      }
    }
    setCheckValue(checked);
  };
  // const onChange = (e: CheckboxChangeEvent) => {
  //   console.log(e.target.checked);
  // };
  const onCheckBoxChange = (checked: CheckboxChangeEvent) => {
    console.log('checked', checked.target.checked);
    setChecked(checked.target.checked);
  };
  const toAdd = (type: string) => {
    setEditOrAddShow(true);
    setType(type);
    setEditCodeFlag('add');
  };
  const remove = (type: string) => {
    if (type == 'primary') {
      setPrimaryRemove(true);
      setSecondaryRemove(false);
    } else {
      setSecondaryRemove(true);
      setPrimaryRemove(false);
    }
  };
  const removeSingle = (beneficiary: beneficiariesForm) => {
    setRemoveConfrimModal(true);
    setRemoveSingleData(beneficiary);
  };
  const updateEdit = (type: string, beneficiary: beneficiariesForm) => {
    setEditOrAddShow(true);
    setType(type);
    setRemoveSingleData(beneficiary);
    setEditCodeFlag('updated');
  };
  const navCurrent = () => {
    let newList = [];
    if (removeSingleData?.beneficiaryAction == 'add') {
      newList = listdata.filter((item) => item.id !== removeSingleData.id);
    } else {
      newList = listdata.map((item) => {
        if (item.id === removeSingleData?.id) {
          return { ...item, beneficiaryAction: 'removed' };
        } else return item;
      });
    }

    setListdata(newList);

    dispatch({
      type: BeneficiariesActionTypes.SET,
      payload: [...newList],
    });
    if (firstFlag) {
      setFirstFlag(false);
    }
    setPrimaryRemove(false);
    setSecondaryRemove(false);
  };

  const submitChanges = (values: PEPForm) => {
    if (oldCheckValue && oldCheckValue === checkValue) {
      setMes('life.MakeRequest.hasnochange');
      return;
    }
    if (!checkValue) {
      if (totalShares !== '100%' && primaryData.filter((item) => item.beneficiaryAction != 'removed').length != 0) {
        setPTotalS(true);
      }
      if (totalSharesSec !== '100%' && secondary.filter((item) => item.beneficiaryAction != 'removed').length != 0) {
        setSTotalS(true);
      }
      if (totalShares != '100%' && primaryData.filter((item) => item.beneficiaryAction != 'removed').length != 0) {
        setMes('life.beneficiaries.pTotal');
        return;
      } else if (
        totalSharesSec != '100%' &&
        secondary.filter((item) => item.beneficiaryAction != 'removed').length != 0
      ) {
        setMes('life.beneficiaries.sTotal');
        return;
      } else {
        setMes('');
      }
    }
    setPep({ type: 'SAVE_PEP', payload: { ...values } });
    const result = listdata.every((item1) => {
      const matchingItem = oldBeneficiariesList.find((item2) => item2.id === item1.id);
      return (
        matchingItem &&
        (Object.keys(item1) as (keyof beneficiariesForm)[]).every(
          (key) =>
            key != 'beneficiaryAction' && item1.beneficiaryAction != 'removed' && item1[key] === matchingItem[key],
        )
      );
    });
    if (listdata.some((item) => item.beneficiaryAction != 'no change') && !result)
      navigate('/LIBenefiaries/SubmitAfterConfirm', {
        state: { checkValue },
      });
    else setMes('life.MakeRequest.hasnochange');
  };
  const handleEsCancel = () => {
    setChangeEsConfrimModal(false);
    setCheckValue(false);
  };
  const handleEsConfirm = () => {
    // let newList = [];
    setFirstFlag(false);
    setChangeEsConfrimModal(false); //關閉彈窗
    setCheckValue(true);
    // setListdata(listdata.map((item) => ({ ...item, beneficiaryAction: 'removed' })));
    dispatch({
      type: BeneficiariesActionTypes.SET,
      payload: [
        ...(listdata.filter((i) => i.beneficiaryAction != 'add').length > 0
          ? listdata
              .filter((i) => i.beneficiaryAction != 'add')
              .map((item) => ({ ...item, beneficiaryAction: 'removed' }))
          : []),
      ],
    });
  };
  return (
    <ViewBeneficiariesContainer className="view-beneficiaries-new">
      {!editOrAddShow ? (
        <>
          <div style={{ position: 'relative' }}>
            {startLoading && (
              <div
                style={{
                  width: '100%',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  zIndex: 999,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Spinner />
              </div>
            )}

            <StyledBlock className={`account-detail ${policyNumber ? '' : 'back-f'}`}>
              <StyledBlock className="back-f" style={{ marginBottom: 0 }}>
                <Androw justify="start" paddingFlag="16px">
                  <Row
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      // flexWrap: 'nowrap',
                      width: '100%',
                      // flexDirection: 'row',
                    }}
                  >
                    <AndCol style={{ margin: '0 16px' }} className="font-size26 grey-font">
                      {t('life.policies.appointment')}
                    </AndCol>
                    {!EditCode && !EditDisable && policyNumber != '' && (
                      <button
                        style={{
                          padding: '10px 0 0 0',
                          marginRight: 10,
                          background: 'transparent',
                          border: 'none',
                          cursor: 'pointer',
                        }}
                        onClick={Edit}
                      >
                        <img src={edit} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
                        <span
                          style={{
                            fontSize: '17px',
                            fontFamily: 'Roboto500',
                            color: '#C21B17',
                          }}
                        >
                          {t('life.MakeRequest.contact.Edit')}
                        </span>
                      </button>
                    )}
                    {((!EditCode && EditDisable) || policyNumber == '') && (
                      <button
                        style={{
                          padding: '10px 0 0 0',
                          background: 'transparent',
                          border: 'none',
                          marginRight: 10,
                        }}
                        disabled
                      >
                        <img src={editdisabled} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
                        <span
                          style={{
                            fontSize: '17px',
                            fontFamily: 'Roboto500',
                            color: '#B0B2B3',
                          }}
                        >
                          {t('life.MakeRequest.contact.Edit')}
                        </span>
                      </button>
                    )}
                  </Row>
                  {EditDisable && policyNumber !== '' && (
                    <AndCol>
                      <div
                        style={{
                          fontSize: '17px',
                          fontFamily: 'Roboto700',
                          color: '#E9673D',
                        }}
                      >
                        {Errmessage}
                      </div>
                    </AndCol>
                  )}
                  {!firstFlag && (
                    <AndCol className="font-setting700 font-size17" span={22} style={{ color: '#E9573D' }}>
                      {t('life.beneficiaries.submitUp')}
                    </AndCol>
                  )}
                  <AntDivider style={{ margin: '12px 0 0 0' }}></AntDivider>
                </Androw>
                {policyNumber && (
                  <>
                    <Androw
                      justify="start"
                      paddingFlag="16px"
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        paddingBottom: 10,
                        opacity: checkValue || EditCode ? '100%' : '40%',
                      }}
                    >
                      <AndCol
                        style={{
                          fontSize: '20px',
                          fontFamily: 'Roboto400',
                          color: '#20252B',
                          marginLeft: 32,
                        }}
                      >
                        <p style={{ marginBottom: 0 }}>{t('life.policies.noBeneficiaries')}</p>
                        <p style={{ marginBottom: 0, fontSize: '17px' }}>{t('life.beneficiaries.own')}</p>
                        {data?.noDesignatedBeneficiaryFlag == 'Y' && (
                          <div
                            style={{
                              background: '#E9573D',
                              borderRadius: '12px',
                              padding: '4px 8px',
                              fontSize: '15px',
                              fontFamily: 'Roboto700',
                              color: '#FFF',
                              display: 'inline-block',
                              height: '24px',
                              lineHeight: '17px',
                            }}
                          >
                            {t('life.MakeRequest.contact.UnderReview')}
                          </div>
                        )}
                      </AndCol>
                      <AndCol>
                        <Switch onChange={SwitchonChange} checked={checkValue} disabled={!EditCode} />
                      </AndCol>
                    </Androw>
                    <Androw
                      justify="space-between"
                      className="pointer"
                      style={{
                        opacity: checkValue ? 0.4 : 1,
                      }}
                    >
                      <AndCol span={22}>
                        <Androw justify="start">
                          <FlexCol>
                            <span className="font-size20" style={{ marginLeft: '12px' }}>
                              {t('life.policies.hasnoBeneficiaries')}
                            </span>
                          </FlexCol>
                        </Androw>
                      </AndCol>
                      <AndCol>
                        <Androw justify="start">
                          <FlexCol>
                            <span className="font-size17 grey-font" style={{ marginLeft: '12px' }}>
                              {t('life.policies.hasBenefitDes')}
                            </span>
                          </FlexCol>
                        </Androw>
                      </AndCol>
                      {data?.designatedBeneficiaryFlag == 'Y' && (
                        <AndCol span={22}>
                          <Androw justify="start">
                            <div
                              style={{
                                background: '#E9573D',
                                borderRadius: '12px',
                                padding: '4px 8px',
                                fontSize: '15px',
                                fontFamily: 'Roboto700',
                                color: '#FFF',
                                display: 'inline-block',
                                height: '24px',
                                marginLeft: '12px',
                                lineHeight: '17px',
                              }}
                            >
                              {t('life.MakeRequest.contact.UnderReview')}
                            </div>
                          </Androw>
                        </AndCol>
                      )}
                    </Androw>
                    <div className={`beneficiaries-content ${secondaryRemove && EditCode ? 'not-edit' : ''}`}>
                      {((EditCode && !checkValue) ||
                        (primaryData?.length > 0 &&
                          !primaryData?.some((item) => item.beneficiaryAction == 'removed'))) && (
                        <>
                          <Androw justify="start">
                            <AntDivider style={{ margin: '12px 0' }}></AntDivider>
                          </Androw>
                          <Androw justify="start">
                            <AndCol
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%',
                              }}
                            >
                              <div className="tagging">
                                <span className="font-size17 font-setting500 grey-font">
                                  {t('life.policies.Primarybeneficiaries')}
                                </span>
                              </div>
                              {data?.designatedBeneficiaryFlag == 'N' && data?.primaryBeneficiaryFlag == 'Y' && (
                                <div
                                  style={{
                                    background: '#E9573D',
                                    borderRadius: '12px',
                                    padding: '4px 8px',
                                    fontSize: '15px',
                                    fontFamily: 'Roboto700',
                                    color: '#FFF',
                                    display: 'inline-block',
                                    height: '24px',
                                    lineHeight: '17px',
                                  }}
                                >
                                  {t('life.MakeRequest.contact.UnderReview')}
                                </div>
                              )}
                            </AndCol>
                          </Androw>
                          <DividerLine></DividerLine>
                          <Androw justify="start">
                            <AndCol style={{ width: '100%' }}>
                              <Androw justify="start">
                                <Col lg={19} md={19} sm={15} xs={15}>
                                  <div className="tagging">
                                    <span className="font-size17 font-setting500">{t('life.beneficiaries.name')}</span>
                                    <span className="font-size17 grey-font">{t('life.policies.relationship')}</span>
                                  </div>
                                </Col>
                                <Col span={1}>
                                  <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
                                </Col>
                                <Col lg={4} md={4} sm={7} xs={7}>
                                  <div
                                    className="tagging"
                                    style={{
                                      flexDirection: 'row',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      height: '100%',
                                      marginLeft: '0',
                                      padding: isEnglish ? '0' : '0 30px',
                                    }}
                                  >
                                    <span
                                      className="font-size17 font-setting500 grey-font"
                                      style={{ textAlign: 'center' }}
                                    >
                                      {t('life.policies.ShareAllocation')}
                                    </span>
                                  </div>
                                </Col>
                              </Androw>
                            </AndCol>
                          </Androw>
                          <DividerLine></DividerLine>
                          {primaryData?.map((beneficiary, index) => {
                            return (
                              beneficiary.beneficiaryAction != 'removed' && (
                                <Fragment key={index}>
                                  <Androw justify="start">
                                    <AndCol style={{ width: '100%' }}>
                                      <Androw justify="start">
                                        <Col
                                          lg={19}
                                          md={19}
                                          sm={15}
                                          xs={15}
                                          style={{
                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                            alignItems: 'center',
                                          }}
                                        >
                                          {beneficiary.irrevocableFlag && <img src={IrrevocableIcon} alt="" />}
                                          {beneficiary.beneficiaryAction == 'add' && <img src={Added} alt="" />}
                                          <div
                                            className={`tagging  ${
                                              beneficiary.irrevocableFlag || beneficiary.beneficiaryAction == 'add'
                                                ? 'tagging-special mg-l'
                                                : ''
                                            }`}
                                          >
                                            <span className="font-size17 font-setting500">
                                              {beneficiary.surname + ' ' + beneficiary.givenName}
                                            </span>
                                            <span className="font-size17 grey-font">
                                              {isEnglish
                                                ? beneficiary.relationshipDesc
                                                : beneficiary.relationshipDescTc}
                                            </span>
                                          </div>
                                        </Col>
                                        <Col span={1}>
                                          <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
                                        </Col>
                                        <Col lg={4} md={4} sm={7} xs={7}>
                                          <div
                                            className="tagging"
                                            style={{
                                              flexDirection: 'row',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              height: '100%',
                                              marginLeft: '0',
                                              position: 'relative',
                                            }}
                                          >
                                            <span className="font-size17" style={{ textAlign: 'center' }}>
                                              {beneficiary.share?.indexOf('%') != -1
                                                ? beneficiary.share
                                                : beneficiary.share == '0'
                                                ? '-'
                                                : beneficiary.share + '%'}
                                            </span>
                                            {EditCode &&
                                              (!primaryRemove ? (
                                                beneficiary?.clientType != 'C' && (
                                                  <img
                                                    src={edit}
                                                    style={{
                                                      position: 'absolute',
                                                      right: 0,
                                                      width: '16px',
                                                      height: '16px',
                                                      cursor: 'pointer',
                                                    }}
                                                    onClick={() => updateEdit('primary', beneficiary)}
                                                  />
                                                )
                                              ) : (
                                                <img
                                                  src={removeIcon}
                                                  style={{
                                                    position: 'absolute',
                                                    right: 0,
                                                    width: '16px',
                                                    height: '16px',
                                                    cursor: 'pointer',
                                                  }}
                                                  alt=""
                                                  onClick={() => removeSingle(beneficiary)}
                                                />
                                              ))}
                                          </div>
                                        </Col>
                                      </Androw>
                                    </AndCol>
                                  </Androw>
                                  <DividerLine></DividerLine>
                                </Fragment>
                              )
                            );
                          })}
                          <Androw justify="center" align="middle" style={{ height: '48px' }}>
                            <AndCol>
                              <span
                                style={{ fontWeight: 'normal', fontSize: 18 }}
                                className={pTotalS ? 'btn-border' : ''}
                              >
                                {t('life.beneficiaries.Totalshares', {
                                  totalShares: totalShares == '0%' ? '-' : totalShares,
                                })}
                                {/* {} */}
                              </span>
                            </AndCol>
                          </Androw>
                          {pTotalS && (
                            <>
                              <DividerLine></DividerLine>
                              <Androw justify="start" align="middle" style={{ height: '48px' }}>
                                <AndCol>
                                  <span style={{ fontWeight: 'normal', fontSize: 18, color: '#C21B17' }}>
                                    {t('life.beneficiaries.shareTotal')}
                                  </span>
                                </AndCol>
                              </Androw>
                            </>
                          )}
                          <DividerLine></DividerLine>
                          {EditCode && !checkValue && (
                            <Androw
                              className=" ChageBeneficialPage"
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: !primaryRemove ? 'space-between' : 'center',
                                alignItems: 'center',
                                paddingLeft: 20,
                                paddingRight: 20,
                                paddingTop: 16,
                              }}
                            >
                              {!primaryRemove ? (
                                <>
                                  <Button
                                    className="subbutton"
                                    disabled={
                                      secondaryRemove ||
                                      primaryData.filter((item) => item.beneficiaryAction != 'removed').length +
                                        secondary.filter((item) => item.beneficiaryAction != 'removed').length >=
                                        10
                                    }
                                    onClick={() => toAdd('primary')}
                                  >
                                    {t('life.beneficiaries.add')}
                                  </Button>

                                  <Button
                                    onClick={() => remove('primary')}
                                    style={{
                                      opacity: primaryData.length <= 1 ? 0.4 : 1,
                                    }}
                                    disabled={primaryData.length <= 1 || secondaryRemove}
                                    className="subbutton"
                                  >
                                    {t('life.beneficiaries.remove')}
                                  </Button>
                                </>
                              ) : (
                                <>
                                  {/* <Button
                                    className="subbutton"
                                    onClick={() => {
                                      setPrimaryRemove(false);
                                      if (removeSingleData) setFirstFlag(false);
                                    }}
                                  >
                                    {t('life.beneficiaries.save')}
                                  </Button> */}

                                  <Button
                                    onClick={() => {
                                      setPrimaryRemove(false);
                                    }}
                                    className="subbutton"
                                  >
                                    {t('life.beneficiaries.cancel')}
                                  </Button>
                                </>
                              )}
                            </Androw>
                          )}
                          {primaryData.some((item) => item.irrevocableFlag) && (
                            <>
                              <Androw justify="start" style={{ paddingBottom: '26px' }}>
                                <AndCol style={{ marginRight: '9px' }}>
                                  <img src={IrrevocableIcon} alt="" />
                                </AndCol>
                                <Col>
                                  <span className="font-size17 grey-font">{t('life.policies.Irrevocable')}</span>
                                </Col>
                              </Androw>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}
              </StyledBlock>
              {policyNumber && (
                <>
                  {((EditCode && !checkValue) ||
                    (secondary.length > 0 && !secondary?.some((item) => item.beneficiaryAction == 'removed'))) && (
                    <StyledBlock className="back-f" style={{ marginBottom: 0 }}>
                      <div
                        className={`beneficiaries-content ${primaryRemove ? 'not-edit' : ''}`}
                        style={{ marginTop: '24px' }}
                      >
                        <Androw justify="start" style={{ paddingTop: '26px' }}>
                          {/* <AntDivider style={{ margin: '12px 0' }}></AntDivider> */}
                          <AndCol
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              width: '100%',
                            }}
                          >
                            <div className="tagging">
                              <span className="font-size17 font-setting500 grey-font">
                                {t('life.policies.SecondaryTitle')}
                              </span>
                            </div>
                            {data?.designatedBeneficiaryFlag == 'N' && data?.secondaryBeneficiaryFlag == 'Y' && (
                              <div
                                style={{
                                  background: '#E9573D',
                                  borderRadius: '12px',
                                  padding: '4px 8px',
                                  fontSize: '15px',
                                  fontFamily: 'Roboto700',
                                  color: '#FFF',
                                  display: 'inline-block',
                                  height: '24px',
                                  lineHeight: '17px',
                                }}
                              >
                                {t('life.MakeRequest.contact.UnderReview')}
                              </div>
                            )}
                          </AndCol>
                        </Androw>
                        <DividerLine></DividerLine>
                        <Androw justify="start">
                          <AndCol style={{ width: '100%' }}>
                            <Androw justify="start">
                              <Col lg={19} md={19} sm={15} xs={15}>
                                <div className="tagging">
                                  <span className="font-size17 font-setting500">{t('life.beneficiaries.name')}</span>
                                  <span className="font-size17 grey-font">{t('life.policies.relationship')}</span>
                                </div>
                              </Col>
                              <Col span={1}>
                                <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
                              </Col>
                              <Col lg={4} md={4} sm={7} xs={7}>
                                <div
                                  className="tagging"
                                  style={{
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '100%',
                                    marginLeft: '0',
                                    padding: isEnglish ? '0' : '0 30px',
                                  }}
                                >
                                  <span
                                    className="font-size17 font-setting500 grey-font"
                                    style={{ textAlign: 'center' }}
                                  >
                                    {t('life.policies.ShareAllocation')}
                                  </span>
                                </div>
                              </Col>
                            </Androw>
                          </AndCol>
                        </Androw>
                        <DividerLine></DividerLine>
                        {secondary?.map((beneficiary, index) => {
                          return (
                            beneficiary.beneficiaryAction != 'removed' && (
                              <Fragment key={index}>
                                <Androw justify="start">
                                  <AndCol style={{ width: '100%' }}>
                                    <Androw justify="start">
                                      <Col
                                        lg={19}
                                        md={19}
                                        sm={15}
                                        xs={15}
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'flex-start',
                                          alignItems: 'center',
                                        }}
                                      >
                                        {beneficiary.irrevocableFlag && <img src={IrrevocableIcon} alt="" />}
                                        {beneficiary.beneficiaryAction == 'add' && <img src={Added} alt="" />}
                                        <div
                                          className={`tagging  ${
                                            beneficiary.irrevocableFlag || beneficiary.beneficiaryAction == 'add'
                                              ? 'tagging-special mg-l'
                                              : ''
                                          }`}
                                        >
                                          <span className="font-size17 font-setting500">
                                            {beneficiary.surname + ' ' + beneficiary.givenName}
                                          </span>
                                          <span className="font-size17 grey-font">
                                            {isEnglish ? beneficiary.relationshipDesc : beneficiary.relationshipDescTc}
                                          </span>
                                        </div>
                                      </Col>
                                      <Col span={1}>
                                        <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
                                      </Col>
                                      <Col lg={4} md={4} sm={7} xs={7}>
                                        <div
                                          className="tagging"
                                          style={{
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '100%',
                                            marginLeft: '0',
                                            position: 'relative',
                                          }}
                                        >
                                          <span className="font-size17" style={{ textAlign: 'center' }}>
                                            {beneficiary.share?.indexOf('%') != -1
                                              ? beneficiary.share
                                              : beneficiary.share == '0'
                                              ? '-'
                                              : beneficiary.share + '%'}
                                          </span>
                                          {EditCode &&
                                            (!secondaryRemove ? (
                                              beneficiary?.clientType != 'C' && (
                                                <img
                                                  src={edit}
                                                  style={{
                                                    position: 'absolute',
                                                    right: 0,
                                                    width: '16px',
                                                    height: '16px',
                                                    cursor: 'pointer',
                                                  }}
                                                  onClick={() => updateEdit('secondary', beneficiary)}
                                                />
                                              )
                                            ) : (
                                              <img
                                                src={removeIcon}
                                                style={{
                                                  position: 'absolute',
                                                  right: 0,
                                                  width: '16px',
                                                  height: '16px',
                                                  cursor: 'pointer',
                                                }}
                                                alt=""
                                                onClick={() => removeSingle(beneficiary)}
                                              />
                                            ))}
                                        </div>
                                      </Col>
                                    </Androw>
                                  </AndCol>
                                </Androw>
                                <DividerLine></DividerLine>
                              </Fragment>
                            )
                          );
                        })}

                        <Androw justify="center" align="middle" style={{ height: '48px' }}>
                          <AndCol>
                            <span
                              style={{ fontWeight: 'normal', fontSize: 18 }}
                              className={sTotalS ? 'btn-border' : ''}
                            >
                              {t('life.beneficiaries.Totalshares', {
                                totalShares: totalSharesSec == '0%' ? '-' : totalSharesSec,
                              })}
                            </span>
                          </AndCol>
                        </Androw>
                        {sTotalS && (
                          <>
                            <DividerLine></DividerLine>
                            <Androw justify="start" align="middle" style={{ height: '48px' }}>
                              <AndCol>
                                <span style={{ fontWeight: 'normal', fontSize: 18, color: '#C21B17' }}>
                                  {t('life.beneficiaries.shareTotal')}
                                </span>
                              </AndCol>
                            </Androw>
                          </>
                        )}
                        <DividerLine></DividerLine>
                        {EditCode && !checkValue && (
                          <Androw
                            className=" ChageBeneficialPage "
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: !secondaryRemove ? 'space-between' : 'center',
                              alignItems: 'center',
                              paddingLeft: 20,
                              paddingRight: 20,
                              paddingTop: 16,
                            }}
                          >
                            {!secondaryRemove ? (
                              <>
                                <Button
                                  className="subbutton"
                                  disabled={
                                    primaryRemove ||
                                    primaryData.filter((item) => item.beneficiaryAction != 'removed').length +
                                      secondary.filter((item) => item.beneficiaryAction != 'removed').length >=
                                      10 ||
                                    primaryData.length == 0
                                  }
                                  onClick={() => toAdd('secondary')}
                                >
                                  {t('life.beneficiaries.add')}
                                </Button>

                                <Button
                                  onClick={() => remove('secondary')}
                                  disabled={secondary.length == 0 || primaryRemove}
                                  className="subbutton"
                                  style={{ opacity: secondary.length == 0 ? 0.4 : 1 }}
                                >
                                  {t('life.beneficiaries.remove')}
                                </Button>
                              </>
                            ) : (
                              <>
                                {/* <Button
                                  className="subbutton"
                                  onClick={() => {
                                    setSecondaryRemove(false);
                                    if (removeSingleData) setFirstFlag(false);
                                  }}
                                >
                                  {t('life.beneficiaries.save')}
                                </Button> */}

                                <Button
                                  onClick={() => {
                                    setSecondaryRemove(false);
                                  }}
                                  className="subbutton"
                                >
                                  {t('life.beneficiaries.cancel')}
                                </Button>
                              </>
                            )}
                          </Androw>
                        )}
                      </div>
                    </StyledBlock>
                  )}
                  <StyledBlock className="back-f">
                    {!EditCode && (
                      <>
                        <Androw justify="start" paddingFlag="16px">
                          <AndCol className="font-size26 grey-font">
                            <div className="tagging">
                              <span className="font-size17">{t('life.MakeRequest.contact.FooterText')}</span>
                            </div>
                          </AndCol>
                        </Androw>
                        <Androw style={{ height: '84px', paddingBottom: '24px' }}>
                          <Androw justify="center" align="middle">
                            <AndCol>
                              <Button type="text" block size="large" onClick={toDownload}>
                                <span className="font-setting500 font-size17 red-font">
                                  {t('life.policies.downloadForm')}
                                </span>
                                <KnowMoreLinkImage src={KnowMoreArrowIcon} alt="know-more-arrow" />
                              </Button>
                            </AndCol>
                          </Androw>
                        </Androw>
                      </>
                    )}
                    {EditCode && (
                      <Form
                        layout={'vertical'}
                        requiredMark={false}
                        form={form}
                        onFinish={submitChanges}
                        validateTrigger={'submit'}
                        className="form beneficiaries-form"
                      >
                        {!checkValue && (
                          <>
                            <DividerLine></DividerLine>
                            <Androw justify="space-between" className="pointer">
                              <AndCol span={22}>
                                <div className="grey-font font-size22 font-setting400">
                                  <span>{t('life.MakeRequest.contact.termstittle')}</span>
                                </div>
                              </AndCol>
                              <AndCol span={22}>
                                <div
                                  className="grey-font font-setting500 font-size17"
                                  style={{
                                    paddingTop: '16px',
                                  }}
                                >
                                  <span>{t('life.beneficiaries.confirm')}</span>
                                </div>
                              </AndCol>
                            </Androw>
                            <AntDivider style={{ margin: '12px 0 8px 0' }}></AntDivider>
                            <div
                              style={{
                                opacity: !pepEdit ? 0.4 : 1,
                              }}
                            >
                              <Androw justify="space-between" className="form-row">
                                <AndCol span={22}>
                                  <BoldLabelFormItem
                                    // rules={[{ required: true, message: t('common.error.requiredField') }]}
                                    // required
                                    initialValue={pep.isDeclaration}
                                    label={
                                      <div className="form-label">
                                        <p
                                          style={{
                                            color: '#6f7072',
                                            fontWeight: 'normal',
                                            fontSize: '15px',
                                            fontFamily: 'Roboto400',
                                            marginBottom: 0,
                                          }}
                                          dangerouslySetInnerHTML={{ __html: t('life.beneficiaries.PEP') }}
                                        ></p>
                                      </div>
                                    }
                                    className="label-form-item"
                                    name="isDeclaration"
                                  >
                                    <Radio.Group
                                      options={[
                                        {
                                          value: 'No',
                                          label: t('common.no'),
                                        },
                                        {
                                          value: 'Yes',
                                          label: t('common.yes'),
                                        },
                                      ]}
                                      disabled={!pepEdit}
                                    />
                                  </BoldLabelFormItem>
                                </AndCol>
                              </Androw>
                              <Form.Item
                                noStyle
                                shouldUpdate={(prevValues, currentValues) =>
                                  prevValues.isDeclaration !== currentValues.isDeclaration
                                }
                              >
                                {({ getFieldValue }) =>
                                  getFieldValue('isDeclaration') === 'Yes' ? (
                                    <>
                                      <DividerLine></DividerLine>
                                      <Androw justify="space-between" className="form-row">
                                        <AndCol span={22}>
                                          <BoldLabelFormItem
                                            rules={[{ required: true, message: t('common.error.requiredField') }]}
                                            // required
                                            label={
                                              <div className="form-label">
                                                <p
                                                  style={{
                                                    fontWeight: 'normal',
                                                    fontSize: '17px',
                                                    fontFamily: 'Roboto500',
                                                    marginBottom: 0,
                                                    color: '#752127',
                                                  }}
                                                >
                                                  {t('life.beneficiaries.pepName')}*
                                                </p>
                                              </div>
                                            }
                                            className="label-form-item"
                                            name="pepName"
                                          >
                                            <Input
                                              size="middle"
                                              placeholder={t('life.beneficiaries.enter', {
                                                content: t('life.beneficiaries.pepName'),
                                              })}
                                              style={{
                                                color: '#20252B',
                                                // backgroundColor: 'transparent',
                                                fontSize: '20px',
                                                fontFamily: 'Roboto400',
                                                padding: '4px 10px',
                                              }}
                                            />
                                          </BoldLabelFormItem>
                                        </AndCol>
                                        <AntDivider style={{ margin: '12px 0 8px 0' }}></AntDivider>
                                        <AndCol span={22}>
                                          <BoldLabelFormItem
                                            rules={[{ required: true, message: t('common.error.requiredField') }]}
                                            // required
                                            label={
                                              <div className="form-label">
                                                <p
                                                  style={{
                                                    fontWeight: 'normal',
                                                    fontSize: '17px',
                                                    fontFamily: 'Roboto500',
                                                    marginBottom: 0,
                                                    color: '#752127',
                                                  }}
                                                >
                                                  {t('life.beneficiaries.pepPosition')}*
                                                </p>
                                              </div>
                                            }
                                            className="label-form-item"
                                            name="pepPosition"
                                          >
                                            <Input
                                              size="middle"
                                              placeholder={t('life.beneficiaries.enter', {
                                                content: t('life.beneficiaries.pepPosition'),
                                              })}
                                              style={{
                                                color: '#20252B',
                                                // backgroundColor: 'transparent',
                                                fontSize: '20px',
                                                fontFamily: 'Roboto400',
                                                padding: '4px 10px',
                                              }}
                                            />
                                          </BoldLabelFormItem>
                                        </AndCol>
                                      </Androw>
                                      <AntDivider style={{ margin: '12px 0 8px 0' }}></AntDivider>
                                      <Androw justify="space-between" className="form-row">
                                        <AndCol span={22}>
                                          <div className="grey-font font-size22 font-setting400">
                                            <span>{t('life.beneficiaries.party')}</span>
                                          </div>
                                        </AndCol>
                                        <AndCol span={22}>
                                          <BoldLabelFormItem
                                            rules={[{ required: true, message: t('common.error.requiredField') }]}
                                            // required
                                            label={
                                              <div className="form-label">
                                                <p
                                                  style={{
                                                    fontWeight: 'normal',
                                                    fontSize: '17px',
                                                    fontFamily: 'Roboto500',
                                                    marginBottom: 0,
                                                    color: '#752127',
                                                  }}
                                                >
                                                  {t('life.beneficiaries.pepRelevant')}*
                                                </p>
                                              </div>
                                            }
                                            className="label-form-item"
                                            name="relevantPartyName"
                                          >
                                            <Input
                                              size="middle"
                                              placeholder={t('life.beneficiaries.enter', {
                                                content: t('life.beneficiaries.pepRelevant'),
                                              })}
                                              style={{
                                                color: '#20252B',
                                                // backgroundColor: 'transparent',
                                                fontSize: '20px',
                                                fontFamily: 'Roboto400',
                                                padding: '4px 10px',
                                              }}
                                            />
                                          </BoldLabelFormItem>
                                        </AndCol>
                                        <AntDivider style={{ margin: '12px 0 8px 0' }}></AntDivider>
                                        <AndCol span={22}>
                                          <BoldLabelFormItem
                                            rules={[{ required: true, message: t('common.error.requiredField') }]}
                                            // required
                                            label={
                                              <div className="form-label">
                                                <p
                                                  style={{
                                                    fontWeight: 'normal',
                                                    fontSize: '17px',
                                                    fontFamily: 'Roboto500',
                                                    marginBottom: 0,
                                                    color: '#752127',
                                                  }}
                                                >
                                                  {t('life.beneficiaries.pepRelationship')}*
                                                </p>
                                              </div>
                                            }
                                            className="label-form-item"
                                            name="pepRelationship"
                                          >
                                            <Input
                                              size="middle"
                                              placeholder={t('life.beneficiaries.enter', {
                                                content: t('life.beneficiaries.pepRelationship'),
                                              })}
                                              style={{
                                                color: '#20252B',
                                                // backgroundColor: 'transparent',
                                                fontSize: '20px',
                                                fontFamily: 'Roboto400',
                                                padding: '4px 10px',
                                              }}
                                            />
                                          </BoldLabelFormItem>
                                        </AndCol>
                                      </Androw>
                                    </>
                                  ) : null
                                }
                              </Form.Item>
                              <DividerLine></DividerLine>

                              <Androw justify="space-between" className="pointer">
                                <AndCol span={22}>
                                  <div className="grey-font font-size15 font-setting400">
                                    <sup>#1</sup>
                                    <span>{t('life.beneficiaries.pepDesc1')}</span>
                                  </div>
                                </AndCol>
                                <AndCol span={22}>
                                  <div className="grey-font font-size15 font-setting400">
                                    <sup>#2</sup>
                                    <span>{t('life.beneficiaries.pepDesc2')}</span>
                                  </div>
                                </AndCol>
                              </Androw>
                            </div>
                          </>
                        )}
                        <Androw justify="space-between" className="pointer">
                          <AntDivider style={{ margin: '12px 0 8px 0' }}></AntDivider>
                          <AndCol span={22} style={{ fontSize: '17px' }}>
                            {/* <AgreementCheckbox onChange={onChange} /> */}
                            <CommonTnc></CommonTnc>
                          </AndCol>
                        </Androw>
                        <Androw justify="space-between" className="pointer" style={{ marginTop: '16px' }}>
                          <AndCol span={22}>
                            <span className="font-size17" style={{ opacity: EditCode ? '100%' : '40%' }}>
                              {t('life.MakeRequest.contact.accepttext2')}
                            </span>
                          </AndCol>
                        </Androw>
                        <Androw justify="space-between" className="pointer" style={{ marginTop: '16px' }}>
                          <AndCol span={22}>
                            <Checkbox checked={checked} onChange={onCheckBoxChange} className="font-size17">
                              {t('life.MakeRequest.contact.agreetext')}
                            </Checkbox>
                          </AndCol>
                        </Androw>

                        <Androw justify="center" style={{ marginTop: '20px' }}>
                          {mes && (
                            <AndCol>
                              <Alert
                                message={t(mes)}
                                type="error"
                                // closable
                                className="error-forgot"
                                style={{ marginBottom: 0 }}
                              />
                            </AndCol>
                          )}
                        </Androw>

                        <Androw
                          className="ChageBeneficialPage "
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            // paddingLeft: 20,
                            // paddingRight: 20,
                            paddingTop: 16,
                          }}
                        >
                          <Button
                            // loading={enquirySubmissionIsLoading || isLoading}
                            disabled={!checked}
                            onClick={() => form.submit()}
                            type="primary"
                            className="submit"
                          >
                            {t('life.enquiry.submit')}
                            {checked}
                          </Button>
                          <Button
                            // loading={enquirySubmissionIsLoading || isLoading}
                            onClick={() => {
                              // setFirstFlag(true);
                              // setPrimaryRemove(false);
                              // setSecondaryRemove(false);
                              // setEditCode(false);
                              navigate('/LIBenefiaries', {
                                state: {
                                  policyNumber: policyNC,
                                  companyCode: companyCodeNc,
                                  key: Math.random(),
                                },
                                replace: true,
                              });
                            }}
                            className="cancel"
                          >
                            {t('life.enquiry.Cancel')}
                          </Button>
                        </Androw>
                      </Form>
                    )}
                  </StyledBlock>
                </>
              )}
              {policyNumber == '' && (
                <StyledBlock className="back-f">
                  <Androw justify="start" paddingFlag="16px">
                    <Col className="font-size26 grey-font">
                      <div className="tagging" style={{ paddingLeft: '4px' }}>
                        <span className="font-size17">
                          {dropData?.length > 0
                            ? t('life.MakeRequest.payment.Pleaseselecttext')
                            : t('life.MakeRequest.payment.Pleaseselecttext2')}
                        </span>
                      </div>
                    </Col>
                    <AntDivider style={{ margin: '12px 0 0 0' }}></AntDivider>
                  </Androw>
                  <Androw justify="start" paddingFlag="16px">
                    <Col className="font-size26 grey-font">
                      <div className="tagging" style={{ paddingLeft: '4px' }}>
                        <span className="font-size17">{t('life.MakeRequest.contact.FooterText')}</span>
                      </div>
                    </Col>
                  </Androw>

                  <Androw style={{ height: '84px', paddingBottom: '24px' }}>
                    <Androw justify="center" align="middle">
                      <AndCol>
                        <Button type="text" block size="large" onClick={toDownload}>
                          <span className="font-setting500 font-size17 red-font">
                            {t('life.policies.downloadForm')}
                          </span>
                          <KnowMoreLinkImage src={KnowMoreArrowIcon} alt="know-more-arrow" />
                        </Button>
                      </AndCol>
                    </Androw>
                  </Androw>
                </StyledBlock>
              )}
            </StyledBlock>
          </div>
          <Modal
            isModalVisible={removeConfrimModal}
            handleModalClose={() => {
              setRemoveConfrimModal(false);
              setRemoveSingleData(undefined);
            }}
            title={t('life.beneficiaries.deleteT')}
            handleModalOk={navCurrent}
            desc={t('life.beneficiaries.deleteDesc')}
            OkContent={t('life.beneficiaries.confirmBtn')}
            cancelContent={t('life.beneficiaries.cancel')}
          ></Modal>
          <Modal
            isModalVisible={changeEsConfrimModal}
            handleModalClose={handleEsCancel}
            title={t('life.beneficiaries.ownEs')}
            handleModalOk={handleEsConfirm}
            desc={t('life.beneficiaries.ownEsDesc')}
            OkContent={t('life.beneficiaries.confirmBtn')}
            cancelContent={t('life.beneficiaries.cancel')}
          ></Modal>
        </>
      ) : (
        <ChangeBeneficiariesCard
          type={type}
          beneficiary={removeSingleData}
          setEditOrAddShow={setEditOrAddShow}
          editCodeFlag={editCodeFlag}
          setFirstFlag={setFirstFlag}
        ></ChangeBeneficiariesCard>
      )}
    </ViewBeneficiariesContainer>
  );
}
